import React from 'react'
import Navigation from '../components/header/Navigation';
import ProductDesignBody from '../components/body/ProductDesignBody';

const ProductDesign = () => {
    return (
        <React.Fragment>
            <Navigation />
            <ProductDesignBody />
        </React.Fragment>
    )
};

export default ProductDesign;